import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Home, Building2, ClipboardList, Ruler, CheckCircle } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Home: Home,
  Building2: Building2,
  ClipboardList: ClipboardList,
  Ruler: Ruler
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#0f172a] mb-4">
            Our <span className="text-[#d4af37]">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Comprehensive construction solutions tailored to your unique vision and requirements
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-[#d4af37]/20 bg-white"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-gradient-to-br from-[#d4af37]/20 to-[#d4af37]/5 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-[#d4af37]" size={32} />
                  </div>
                  <CardTitle className="text-2xl text-[#0f172a] group-hover:text-[#d4af37] transition-colors duration-200">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <CheckCircle className="text-[#d4af37] mr-3 flex-shrink-0 mt-0.5" size={20} />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
